export const formatFileSize = (bytes) => {
  if (bytes === 0 || typeof bytes !== 'number' || isNaN(bytes)) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.max(0, Math.floor(Math.log(bytes) / Math.log(k))); // Ensure i is non-negative
  
  // Handle potential edge case where bytes might be less than 1 after log/pow
  if (!isFinite(i) || i >= sizes.length) {
    // Fallback for extremely large or small numbers if needed, or just return max unit
    const maxIndex = sizes.length - 1;
    return parseFloat((bytes / Math.pow(k, maxIndex)).toFixed(2)) + ' ' + sizes[maxIndex];
  }
  
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
